<template>
  <div class="enterprise-cert-query-page">
    <header>
      <div class="head-wrap">
        <div class="logo">
          <img src="../assets/images/home_logo1.png" alt="" />
        </div>
        <!-- <div>
          <h1>中小企业数字化综合服务公共平台</h1>
          <p>中小企业技能人才及企业服务管理能力考核信息查询平台</p>
          <p>SME Digital Integrated Service Public Platform</p>
        </div> -->
      </div>
    </header>
    <!-- 主体内容区域 -->
    <div class="main-container">
      <div class="card-container">
        <div ref="rightCard" :class="isPC?'classA':'classB'" class="form-card">
          <div class="query-form">
            <div class="title">人员证书查询</div>
            <div class="form-fields">
              <div class="form-group">
                <div class="tit">姓 <span style="width: 1.5rem;display: inline-block"></span> 名</div>
                <el-input
                    v-model="formData1.name"
                    type="text"
                    class="form-input"
                />
              </div>

              <div class="form-group">
                <div class="tit">身份证号</div>
                <el-input
                    v-model="formData1.id_number"
                    type="text"
                    class="form-input"
                />
              </div>

              <!-- 证书编号 -->
              <div class="form-group">
                <div class="tit">证书编号</div>
                <el-input
                    v-model="formData1.certificate_number"
                    type="text"
                    class="form-input"
                />
              </div>
            </div>


            <!-- 查询按钮 -->
            <div class="submit-wrapper">
              <button type="submit" class="submit-button" @click="toSearch1">点击查询</button>
            </div>
          </div>
          <div class="bottom-wrap">
            <div class="tit">查询方式</div>
            <ul class="instructions-list">
              <li
                  v-for="(item, index) in queryInstructions1"
                  :key="index"
                  ref="instructionItems"
                  class="instruction-item"
              >
<!--                <span class="instruction-number">{{ index + 1 }}</span>-->
                <span class="instruction-text">{{ item.key }}</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- 右侧：查询表单 -->
        <div ref="rightCard" class="form-card">
          <div class="query-form">
            <div class="title">企业证书查询</div>
            <div class="form-fields">
              <!-- 单位名称 -->
              <div class="form-group">
                <div class="tit">单位名称</div>
                <el-input
                    v-model="formData.name"
                    type="text"
                    class="form-input"
                />
              </div>

              <!-- 信用代码 -->
              <div class="form-group">
                <div class="tit">信用代码</div>
                <el-input
                    v-model="formData.code"
                    type="text"
                    class="form-input"
                />
              </div>

              <!-- 证书编号 -->
              <div class="form-group">
                <div class="tit">证书编号</div>
                <el-input
                    v-model="formData.number"
                    type="text"
                    class="form-input"
                />
              </div>
            </div>

            <!-- 查询按钮 -->
            <div class="submit-wrapper">
              <button type="submit" class="submit-button" @click="toSearch">点击查询</button>
            </div>
          </div>
          <div class="bottom-wrap">
            <div class="tit">查询方式</div>
            <ul class="instructions-list">
              <li
                  v-for="(item, index) in queryInstructions"
                  :key="index"
                  ref="instructionItems"
                  class="instruction-item"
              >
<!--                <span class="instruction-number"></span>-->
                <span class="instruction-text">{{ index + 1 }}、{{ item.key }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  search_qiye,
  search_rongyu,
  search_user,
  search_person,
  index_config
} from "@/api/index";
export default {
  name: 'EnterpriseCertQueryPage',
  data() {
    return {
      formData: {
        type:6,
        name: '',
        code: '',
        number: ''
      },
      formData1: {
        name: '',
        id_number: '',
        certificate_number: '',
        type: 8,
      },
      queryInstructions: [],
      queryInstructions1: [],
      isPC:false,
      name:'',
      type:2
    };
  },
  mounted() {
    // console.log(this.$route.query)
    // this.name = this.$route.query.name
    // this.type = this.$route.query.type
    // this.formData.type = this.$route.query.typeId
    this.getConfig()
    this.getConfig1()
    if (this.isMobile()) {
      this.isPC = false
    } else {
      this.isPC = true
    }
  },
  methods: {
    getConfig(){
      index_config().then(res => {
        if (res.code == 1) {
          this.queryInstructions = res.data.qiyeinfo
        }
      })
    },
    getConfig1(){
      index_config().then(res => {
        if (res.code == 1) {
          this.queryInstructions1 = res.data.rencaiinfo
        }
      })
    },
    isMobile() {
      const ua = navigator.userAgent;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    },
    toBack(){
      sessionStorage.removeItem('userInfo')
      this.$router.push({
        path: '/',
        query: { }
      })
    },
    toBack1(){
      sessionStorage.removeItem('userInfo')
      this.$router.push({
        path: '/',
        query: { index:1 }
      })
    },
    toSearch(){
      let ajax = {
        ...this.formData
      }
      search_qiye(ajax).then(res => {
        console.log(res)
        if (res.code == 1) {
          if (res.data.length == 0) {
            this.$message({
              message: '暂无查询结果',
              type: 'warning'
            })
          }else{
            sessionStorage.setItem('companyInfo',JSON.stringify(res.data))
            this.$router.push({
              path: '/qyjg',
              query: {}
            })
          }
        }else {
          this.$message({
            message: '暂无查询结果',
            type: 'warning'
          })
        }
      })
    },
    toSearch1(){
      let ajax = {
        ...this.formData1
      }
      search_person(ajax).then(res => {
        console.log(res)
        if (res.code == 1) {
          if (res.data.length == 0) {
            this.$message({
              message: '暂无查询结果',
              type: 'warning'
            })
          }else{
            sessionStorage.setItem('userInfo',JSON.stringify(res.data))
            this.$router.push({
              path: '/grjg',
              query: { }
            })
          }
        }else {
          this.$message({
            message: '暂无查询结果',
            type: 'warning'
          })
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.enterprise-cert-query-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background-image: url("../assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: column;
  }

  .top {
    position: absolute;
    right: 4rem;
    top: 3rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .logo{
      cursor: pointer;
    }
  }
  .top1 {
    width: calc(100% - 40px);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px;
    position: relative;
    img{
      width: 100%;
    }
  }

  .top_btn {
    display: flex;
    align-items: center;
    .btn1 {
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      img{
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
    .btn2 {
      margin-left: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      img{
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }


  .main-container {
    padding: 1rem;
    margin: 0 auto;
    width: calc(100% - 2rem);
    @media (min-width: 768px) {
      max-width: 100rem;
      padding: 0;
    }

    .card-container {
      display: flex;
      flex-direction: column;


      @media (min-width: 768px) {
        flex-direction: row;
        justify-content: center;
        margin-top: 2rem;
      }
      .info-card{
        margin-right: 0rem;
        //margin-bottom: 1rem;
        @media (min-width: 768px) {
          margin-right: 3rem;
          //margin-bottom: .1rem;
        }
      }

      .info-card,
      .form-card {
        //width: 100%;
        //background: rgba(255, 255, 255, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.3);
        background: linear-gradient(270deg, rgba(20, 94, 181, 1), rgba(20, 94, 181, .6));
        border-radius: 0.5rem;
        box-sizing: border-box;
        &:first-child {
          //margin-bottom: 1rem;
        }

        @media (min-width: 768px) {
          //width: calc((100% - 2rem)/2);
          width: 40rem;
          &:first-child {
            margin-right: 5rem;
          }
        }

        .info-title {
          font-size: 1.5rem;
          font-weight: 700;
          text-align: center;
          margin-bottom: 2rem;
          color: #333333;

          @media (min-width: 768px) {
            font-size: 2rem;
            margin-bottom: 4rem;
          }

          .sm-break {
            @media (min-width: 640px) {
              display: inline;
            }
          }
        }

        .instructions-list {
          .instruction-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: .8rem;
            font-size: .9rem;
            @media (min-width: 768px) {
              font-size: 1rem;
            }
            &:last-child{
              margin-bottom: 0;
            }

            .instruction-number {
              background: rgba(255, 255, 255, 0.2);
              color: white;
              width: 1.5rem;
              height: 1.5rem;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 0.875rem;
              margin-right: 1rem;
            }

            .instruction-text {
              color: rgba(255, 255, 255, 0.9);
              flex: 1;
            }
          }
        }

        .query-form {
          display: flex;
          flex-direction: column;
          padding: 2rem 2rem;

          @media (min-width: 768px) {
            padding: 3rem 5rem;
          }

          .title{
            font-size: 1.6rem;
            text-align: center;
            margin-bottom: 1.5rem;
            color: #ffffff;
            @media (min-width: 768px) {
              font-size: 2rem;
              text-align: center;
              margin-bottom: 2.5rem;
              color: #ffffff;
            }
          }

          .form-fields {
            display: flex;
            flex-direction: column;

            .form-group {
              display: flex;
              align-items: center;
              padding: .2rem 1.2rem;
              background-color: #FFFFFF;
              border-radius: 0.375rem;
              margin-bottom: 2rem;
              @media (min-width: 768px) {
                margin-bottom: 4rem;
                padding: .5rem 1.5rem;
              }
              .tit{
                font-size: 1.1rem;
              }
              .form-label {
                color: rgba(255, 255, 255, 0.9);
                font-weight: 500;
                font-size: 1rem;
              }

              .form-input {
                flex: 1;
                color: white;
                font-size: 1rem;
              }
            }
          }

          .submit-wrapper {
            text-align: center;
            .submit-button {
                width: 12rem;
                padding: .6rem 1.3rem;
                background: rgba(255, 255, 255, 0.2);
                color: white;
                font-weight: 500;
                border: 1px solid rgba(255, 255, 255, 0.3);
                border-radius: 0.375rem;
                cursor: pointer;
                transition: all 0.3s;
                box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);
                font-size: 1.1rem;
                @media (min-width: 768px) {
                  width: 16rem;
                  padding: 1rem 1.5rem;
                  background: rgba(255, 255, 255, 0.2);
                  color: white;
                  font-weight: 500;
                  border: 1px solid rgba(255, 255, 255, 0.3);
                  border-radius: 0.375rem;
                  cursor: pointer;
                  transition: all 0.3s;
                  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);
                  font-size: 1.2rem;
                }
            }
          }
        }
      }
    }
  }
}
.enterprise-cert-query-page{
  .head-wrap {
    display: flex;
    align-items: center;
  }
  & header {
    padding: 1rem 1rem;
    //box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    //background: linear-gradient(270deg, #145eb5, rgba(20, 94, 181, .7));


    @media (min-width: 768px) {
      padding: 1.25rem 3rem;
    }
  }

  & .logo {
    margin-right: .8rem;

    @media (min-width: 768px) {
      margin-right: 1rem;
    }
  }

  & .logo img {
    width: 100%;
    // height: 3.3rem;

    @media (min-width: 768px) {
      // width: 5rem;
      // height: 5rem;
    }
  }
}


/deep/.el-input__inner{
  background: #FFFFFF !important;
  font-size: 18px;
  height: 44px;
  border: none;
  flex: 1;
  @media (min-width: 768px) {
    height: 54px;
  }
}
/deep/ input::placeholder {
  color: #333;
}
.bottom-wrap{
  border-top: 1px solid #eeeeee;
  padding: 1.2rem 1.5rem 1rem;
  .tit{
    font-size: 1.2rem;
    font-family: fangsong;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 1rem;
  }
  @media (min-width: 768px) {
    padding: 1.5rem 2rem 1rem;
    .tit{
      font-size: 1.5rem;
      font-family: fangsong;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 1.5rem;
    }
  }
}
.classB{
  margin-bottom: 1rem;
}
</style>
